import Roles from "./Roles";


/**
 * Navigation Links for Staff roles in the system
 */
const OfficerLinks = {
  management: [
    {
      title: "Students",
      icon: "mdi-account-group",
      url: "students",
      roles: [Roles.DepartmentOfficer, Roles.PgCoordinator, Roles.DeanSpgs, Roles.Hod, Roles.AcademicSecretary, Roles.DeanStudentAffair],
    },
    {
      title: "Staff",
      icon: "mdi-account-supervisor-circle",
      url: "lecturers",
      roles: [Roles.Hod, Roles.PgCoordinator],
    },
    {
      title: "External Examiners",
      icon: "mdi-account-check",
      url: "external_examiners",
      roles: [Roles.Hod],
    },
    {
      title: "Results",
      icon: "mdi-book-arrow-left-outline",
      url: "results",
      roles: [Roles.Lecturer],
    },
    {
      title: "Courses",
      icon: "mdi-google-circles-group",
      url: "courses",
      roles: [Roles.DAP, Roles.Hod, Roles.PgCoordinator],
    },
    // {
    //   title: "Student progress status",
    //   icon: "mdi-google-circles-group",
    //   url: "student_progress_status",
    //   roles: [Roles.Hod],
    // },
    {
      title: "Student (Security)",
      icon: "mdi-account-group",
      url: "mystudent",
      roles: [Roles.SecurityOfficer],
    },
    {
      title: "Students Management",
      icon: "mdi-account-group-outline",
      url: "student_management",
      roles: [Roles.StudentManagement, Roles.StudentManagementAdministrative, Roles.PassportOfficer],
    },
      {
          title: "Staff Management",
          icon: "mdi-account-group-outline",
          url: "staff_management",
          roles: [Roles.StaffManagement],
      },
      {
          title: "Audit trails",
          icon: "mdi-account-group",
          url: "audit_trails",
          roles: [Roles.VC, Roles.DVCAcademics, Roles.DVCAdmin, Roles.Senate, Roles.HeadOfSenate],
      },
    {
      title: "Applicants",
      icon: "mdi-account-group",
      url: "application-support",
      roles: [Roles.SupportOfficer, Roles.StudentManagement, Roles.StudentManagementAdministrative, Roles.Bursar],
    },
    {
      title: "Prerequisite Courses",
      icon: "mdi-backburger",
      url: "prerequisites",
      roles: [Roles.Hod, Roles.PgCoordinator],
    },
    {
      title: "Department Management",
      icon: "mdi-archive-cog",
      url: "department_settings",
      roles: [Roles.Hod, Roles.PgCoordinator],
    },
    {
      title: "My Courses",
      icon: "mdi-bank",
      url: "my_courses",
      roles: [Roles.Lecturer],
      academic: true,
    },
    {
      title: "Registrations",
      icon: "mdi-clipboard-text-outline",
      url: "registration_management",
      roles: [Roles.Hod, Roles.PgCoordinator, Roles.LevelAdviser, Roles.Dean, Roles.DAP],
    },
    {
      title: "Results - Department",
      icon: "mdi-chevron-triple-down",
      url: "manage_results",
      roles: [Roles.Hod, Roles.PgCoordinator, Roles.DepartmentOfficer],
    },
    {
      title: "Results - Faculty",
      icon: "mdi-chevron-triple-right",
      url: "manage_results_faculty",
      roles: [Roles.FacultyExamBoard, Roles.FacultyOfficer, Roles.Dean],
    },

    {
      title: "Results - Sub Senate",
      icon: "mdi-chevron-triple-left",
      url: "manage_results_subsenate",
      roles: [Roles.SenateSubCommittee, Roles.DVCAcademics],
    },
    {
      title: "Results - Senate",
      icon: "mdi-chevron-triple-up",
      url: "manage_results_senate",
      roles: [Roles.HeadOfSenate, Roles.Senate],
    },
    {
      title: "Admission",
      icon: "mdi-collage",
      url: "admission",
      roles: [
        Roles.AdmissionOfficer,
        Roles.Clearance,
        Roles.ScreeningVerificationOfficer,
          Roles.ApplicantManagement,
      ],
    },
    {
      title: "Change Of Applicant",
      icon: "mdi-school-outline",
      url: "change_programme_applicants",
      roles: [Roles.ChangedOfProgrammeApplicant],
    },
    {
      title: "Change Of Programme",
      icon: "mdi-school-outline",
      url: "change_programme_students",
      roles: [Roles.Hod],
    },
    {
      title: "Hostel",
      icon: "mdi-home-city",
      url: "hostel",
      roles: [Roles.HostelOfficer],
    },
    { title: 'Notification', icon: 'mdi-bell', url: 'notification', roles: [] },
      {title: 'Evaluations', icon: 'mdi-access-point', url: 'evaluation/evaluations', roles: [Roles.Supervisor, Roles.Hod, Roles.Dean] },
    {
      title: "Student ID Cards",
      icon: "mdi-chevron-triple-up",
      url: "student_id_card",
      roles: [Roles.StudentAffair],
    },
    {
      title: "Data Correction",
      icon: "mdi-chevron-triple-up",
      url: "data_correction",
      roles: [Roles.DataCorrectionVerification],
    },
    {
      title: "Fees",
      icon: "mdi-currency-ngn",
      url: "school_fees",
      roles: [Roles.Bursar, Roles.StudentAccount, Roles.PaymentVerificationOfficer, Roles.StudentManagementAdministrative],
    },
    {
      title: "Biometrics",
      icon: "mdi-fingerprint",
      url: "biometrics",
      roles: [Roles.BiometricOfficer],
    },
      {title: 'Result Mgmt', icon: 'mdi-book-arrow-right-outline', url: 'result_mgmt', roles: [Roles.ResultAdmin]},
      {title: 'Department Curriculum', icon: 'mdi-school-outline', url: 'department_curriculum', roles: [Roles.ResultAdmin]},
    {
      title: "Announcement",
      icon: "mdi-speaker",
      url: "announcement",
      roles: [Roles.AnnouncementOfficer],
    },
    {
      title: "Transcript",
      icon: 'mdi-account',
      url: "transcript_officer",
      roles: [Roles.TranscriptOfficer]
    },
    {
      title: "Statistics",
      icon: "mdi-tune-vertical",
      url: "stats",
      roles: [Roles.StatsOfficer],
    },

      {
          title: "Clearance",
          icon: "mdi-collage",
          url: "officer_clearance",
          roles: [
              // Roles.AdmissionOfficer,
            //  Roles.AdmissionOfficer,
            Roles.Hod,
              Roles.ClearanceAdmin,
              Roles.ClearanceOfficial,
          ],
      },

    {
      title: "Questions",
      icon: "mdi-tune-vertical",
      url: "question",
      roles: [Roles.Lecturer],
    },

    {
      title: 'TimeTable',
      icon: 'mdi-calendar',
      url: 'timetable',
      roles: [Roles.LevelAdviser],
    },

    {
      title:'Level Adviser',
      icon: 'mdi-access-point',
      url: 'level_adviser',
      roles: [Roles.Hod],
    },
  ],

  settings: [
    { title: "Settings", icon: "mdi-cog", url: "settings" },
  ],
};



/**
 * Navigation Links for Admin
 */
const AdminLinks = {
    management: [
        // { title: 'Students', icon: 'mdi-account-group', url: 'students'},
        {title: 'Staff', icon: 'mdi-account-supervisor-circle', url: 'staff'},
        {title: 'Sessions', icon: 'mdi-power-off', url: 'sessions'},
        {title: 'Programmes Types', icon: 'mdi-google-circles-group', url: 'programmes_types'},
        {title: 'Faculties', icon: 'mdi-bank', url: 'faculties'},
        {title: 'Departments', icon: 'mdi-home', url: 'departments'},
        {title: 'Programmes', icon: 'mdi-chevron-triple-up', url: 'programmes'},
        {title: 'Institution', icon: 'mdi-bank', url: 'institution'},
        {title: 'Faculty Deans', icon: 'mdi-account-star', url: 'faculty_deans'},
        {title: 'Head of Departments', icon: 'mdi-account-circle', url: 'head_of_departments'},
        {title: 'Manage Senates', icon: 'mdi-briefcase-account', url: 'manage_senates'},
        {title: 'Manage Students', icon: 'mdi-account-group', url: 'manage_students'},
        {title: 'Fees', icon: 'mdi-currency-ngn', url: 'school_fees'},
        {title: 'Approval', icon: 'mdi-google-circles-group', url: 'approval'},
        {title: 'Audit Trail', icon: 'mdi-account-group', url: 'audit'},
        {title: 'Documents', icon: 'mdi-account-group', url: 'documents'},
        {title: 'Portal Documents', icon: 'mdi-account', url: 'portal_documents'}
    ],

    settings: [
        {title: 'Configurations (System)', icon: 'mdi-cog', url: 'system_settings'},
        {title: 'Configurations (Misc)', icon: 'mdi-cog-outline', url: 'configuration_misc'},
        {title: 'Nationality', icon: 'mdi-flag', url: 'nationality'},
        {title: 'Profile Settings', icon: 'mdi-shield-account', url: 'settings'},
        {title: "Approval", icon: 'mdi-google-circles-group', url: 'approval'},
    ]
}


/**
 * Navigation Links for student
 */
const StudentLinks = {
    management: [
        { title: 'Fees', icon: 'mdi-currency-ngn', url: 'fees', cleared: true, mustBePermanent: false },
        { title: 'Bio Data', icon: 'mdi-database', url: 'biodata', cleared: true,  mustBePermanent: false },
        { title: 'Other payment', icon: 'mdi-currency-ngn', url: 'other_fees', cleared: false, mustBePermanent: false },
        { title: 'Course Registration', icon: 'mdi-alpha-c-circle', url: 'course-registration', cleared: true, mustBePermanent: true},
        { title: 'Time Table', icon: 'mdi-calendar-clock', url: 'time-table', cleared: true, mustBePermanent: true},
        { title: 'Results', icon: 'mdi-application-edit', url: 'results', cleared: true, mustBePermanent: true },
        { title: 'Accommodation', icon: 'mdi-home', url: 'accommodation', cleared: true, mustBePermanent: true },
        { title: 'Change Programme', icon: 'mdi-domain', url: 'programme', cleared: true, mustBePermanent: true },
        { title: 'My Documents', icon: 'mdi-file-multiple', url: 'student_document', cleared: true, mustBePermanent: true },
        { title: 'Notification', icon: 'mdi-bell', url: 'notification', cleared: true, mustBePermanent: true },
        { title: 'Clearance', icon: 'mdi-access-point', url: 'clearance', cleared: true, mustBePermanent: false }, //temp disabled
        { title: 'Evaluations', icon: 'mdi-access-point', url: 'evaluation/evaluations', cleared: true, mustBePermanent: true },
        { title: 'Support', icon: 'mdi-help-circle', url: 'support', cleared: true, mustBePermanent: false },
    ],

    settings: [
        { title: 'Profile Settings', icon: 'mdi-shield-account', url: 'settings', cleared: false, mustBePermanent: false},
    ]
}

export default {
    OfficerLinks: OfficerLinks,
    AdminLinks: AdminLinks,
    StudentLinks: StudentLinks
};
